<template>
  <div class="site-section-v site-container TeamDetail">
    <div class="author-detail">
      <div class="author-detail-image">
        <logo-icon :active="true" />
        <img :src="member.image" alt="" />
      </div>
      <div class="author-detail-text">
        <h2 class="text-grey-dark">{{ member.name }}</h2>
        <h3 class="text-orange">Áreas de atuação</h3>
        <p class="author-detail-text-position">{{ member.area }}</p>
        <div class="author-detail-text-info">
          <div class="item">
            <map-marker-icon />
            <span>{{ member.unit }}</span>
          </div>
          <div class="item">
            <phone-icon />
            <span v-if="member.cell_phone">{{ member.cell_phone }} | </span>
            <span> {{ member.phone }}</span>
          </div>
          <div class="item">
            <img src="@/assets/img/svg/email.svg" width="20" />
            <span>{{ member.email }}</span>
          </div>
        </div>
        <!-- <button class="button button-orange">
          <img src="@/assets/img/svg/white_whatsapp.svg" class="icon" />
          <span>ENVIE UMA MENSAGEM</span>
        </button> -->
      </div>
      <div class="author-detail-qrcode">
        <p>
          <img src="@/assets/img/svg/mobile_qr_code.svg" width="25" />
          <span><strong>Escaneie o código</strong> e salve o contato</span>
        </p>
        <div v-html="member.qrCode" class="qr-code"></div>
      </div>
    </div>
    <hr />
    <h3 class="text-blue">Currículo</h3>
    <div v-html="member.text"></div>
    <!-- <ul class="text-grey-dark">
      <li
        v-for="(text, index) in member.Curriculum.split('\r\n')"
        :key="`text-curriculum-${index}`"
      >
        {{ text }}
      </li>
    </ul> -->
    <hr />
    <form-contact title="Entre em Contato" :id="member.id">
      <template #info><contact-info /></template>
    </form-contact>
    <hr />

    <section>
      <h2 class="text-center text-orange">Últimos Artigos</h2>
      <div class="post-list post-list-mobile-grid-v">
        <div class="post-list-item" v-for="post in posts" :key="post.id">
          <post-card
            :type="post.category"
            :is-square-cover="
              currentCategory && currentCategory.type == 'podcast'
            "
            :post="post"
          />
        </div>
      </div>
    </section>
    <download-app />
  </div>
</template>

<script>
import FormContact from "@/components/FormContact";
import ContactInfo from "@/components/ContactInfo";
import LogoIcon from "@/components/Svg/LogoIcon";
import DownloadApp from "@/components/Home/DownloadApp";
import PhoneIcon from "@/components/Svg/PhoneIcon";
import MapMarkerIcon from "@/components/Svg/MapMarkerIcon";
import PostCard from "@/components/Blog/PostCard";
import api from "../../services/api";

export default {
  components: {
    DownloadApp,
    LogoIcon,
    FormContact,
    ContactInfo,
    MapMarkerIcon,
    PhoneIcon,
    PostCard,
  },

  data() {
    return {
      member: {},
      posts: [],
    };
  },

  methods: {
    async detail() {
      const { data: member } = await api.get(`team/${this.$route.params.slug}`);
      this.member = member;
      this.posts = member.posts;
    },
  },

  async beforeMount() {
    await this.detail();
  },
};
</script>
